<div class="datawrapper-container">
  <h5 class="datawrapper-header">{{ value().title }}</h5>

  @if (value().subtitle) {
    <h5 class="datawrapper-subheader">
      <span>{{ value().subtitle }}</span>
    </h5>
  }

  <iframe
    #datawrapperIframe
    title="{{ value().title }}"
    class="datawrapper"
    aria-label="Interactive chart"
    [src]="iframeSrc()"
    [style.height.px]="iframeHeight()"
    data-external="1"
  >
  </iframe>

  @if (value().attribution) {
    <div class="datawrapper-attribution">Source: {{ value().attribution }}</div>
  }
</div>
